import { useTranslator } from '@Localization';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode, useState } from 'react';
interface IFiltersDropdownRowProps {
  label: string;
  count: number;
  children?: ReactNode;
}

export const FiltersDropdownRow = observer((props: IFiltersDropdownRowProps): ReactElement => {
  const { label, count, children } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { t } = useTranslator();

  const toggle = (): void => {
    setIsOpen((prev) => !prev);
  };

  if (count === 0) {
    return <></>;
  }

  return (
    <div className='filter-modal-line'>
      <div className='label'>{label}:</div>
      <div className='value'>
        {count > 4 ? (
          <Accordion
            expanded={isOpen}
            onChange={toggle}
          >
            <AccordionSummary>{isOpen ? t('hide_x_values', { count }) : t('show_x_values', { count })}</AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
          </Accordion>
        ) : (
          <>{children}</>
        )}
      </div>
    </div>
  );
});
